import { Content } from "./styled";
import logo from "../../../assets/logo_plantando.png";
// import doar_icon from "../../../assets/icons/doar.svg";
import forum_icon from "../../../assets/icons/forum.svg";
import grupos_icon from "../../../assets/icons/grupos.svg";
import minhas_arvores_icon from "../../../assets/icons/minhas_arvores.svg";
import configuracoes_icon from "../../../assets/icons/settings.svg";
import perfil_icon from "../../../assets/icons/perfil.svg";
import mapa_icon from "../../../assets/icons/mapa.svg";
import plantar_icon from "../../../assets/icons/plantar.svg";
import gerenciamento_icon from "../../../assets/icons/gerenciamento.svg";
import logout_icon from "../../../assets/icons/logout.svg";
import { Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../utils/config";
import DeleteDialog from "../DeleteDialog";
import { useEffect, useState } from "react";
import Usuario from "../../../models/Usuario";
import { ehAdministrador } from "../../../utils/papeis";
import { mesclarTipoNaSessao } from "../../../utils/deixarProfissional";
import usePendentes from "../AdminLayout/usePendentes";
import useMenuColapsavel from "./useMenuColapsavel";
import BotaoColapsar from "./BotaoColapsar";

function SideBar({ usuario, children, setUsuario}) {
  const path = window.location.pathname.split('/')[1]
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();
  const [colapsado, alternarMenu] = useMenuColapsavel();
  // Pedidos de perfil Profissional aguardando: o selo vai no link do painel
  // administrativo, que só o administrador vê.
  const pendentes = usePendentes(ehAdministrador(usuario));

  // O papel guardado vem do login. Se o administrador mudou o papel desta conta (promoveu,
  // rebaixou), o menu e os bloqueios so mudavam ao entrar de novo: confere ao abrir cada tela.
  useEffect(() => {
    if (!usuario?.id) return;
    let vivo = true;
    Usuario.findById(usuario.id).then((r) => {
      const tipo = r?.data?.tipo;
      if (!vivo || !tipo) return;
      // A SESSAO e o que vale no proximo carregamento; a store pode ja ter sido atualizada por
      // outra parte da tela e a sessao continuar velha: compara com as duas.
      let naSessao = null;
      try { naSessao = JSON.parse(sessionStorage.getItem('usuario'))?.tipo; } catch (e) { /* sem sessao */ }
      if (naSessao && naSessao !== tipo) {
        try {
          sessionStorage.setItem('usuario', JSON.stringify(mesclarTipoNaSessao(sessionStorage.getItem('usuario'), tipo)));
        } catch (e) { /* so a store muda */ }
      }
      if (tipo !== usuario.tipo) setUsuario({ ...usuario, tipo });
    });
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario?.id]);

  function logout() {
    sessionStorage.removeItem('usuario');
    setUsuario(Usuario.model);
    navigate('/login');
  }

  return (
    <Content>
      <div className={`sidebar ${colapsado ? "colapsado" : ""}`} id="menu-lateral">
        <BotaoColapsar colapsado={colapsado} onClick={alternarMenu} controla="menu-lateral" />
        <div className="top-logo">
          <img src={logo} alt="Logo Plantando para o planeta" />
        </div>

        <nav>
          <Link to="/plantar" className={`nav-item ${path === "plantar" && 'active'} `} title={colapsado ? "Plantar" : undefined}>
            <img src={plantar_icon} alt="Icone de plantar" />
            <span>Plantar</span>
          </Link>

          <Link to="/minhas-arvores" className={`nav-item ${path === "minhas-arvores" && 'active'} `} title={colapsado ? "Meus Plantios" : undefined}>
            <img src={minhas_arvores_icon} alt="Icone de minhas árvores" />
            <span>Meus Plantios</span>
          </Link>

          <Link to="/mapa" className={`nav-item ${path === "mapa" && 'active'} `} title={colapsado ? "Mapa" : undefined}>
            <img src={mapa_icon} alt="Icone de mapa" />
            <span>Mapa</span>
          </Link>

          <Link to="/grupos" className={`nav-item ${path === "grupos" && 'active'} `} title={colapsado ? "Grupos" : undefined}>
            <img src={grupos_icon} alt="Icone de grupos" />
            <span>Grupos</span>
          </Link>

          {/*<Link to="/doar" className={`nav-item ${path === "doar" && 'active'} `} title={colapsado ? "Doar" : undefined}>
            <img src={doar_icon} alt="Icone de doar"/>
            <span>Doar</span>
          </Link>*/}

          <Link to="/forum" className={`nav-item ${path === "forum" && 'active'} `} title={colapsado ? "Fórum" : undefined}>
            <img src={forum_icon} alt="Icone de forum" />
            <span>Fórum</span>
          </Link>

          <Link to="/perfil" className={`nav-item ${path === "perfil" && 'active'} `} title={colapsado ? "Perfil" : undefined}>
            <img src={perfil_icon} alt="Icone de perfil" />
            <span>Perfil</span>
          </Link>

          <Link to="/configuracoes" className={`nav-item ${path === "configuracoes" && 'active'} `} title={colapsado ? "Configurações" : undefined}>
            <img src={configuracoes_icon} alt="Icone de configuracoes" />
            <span>Configurações</span>
          </Link>


          {/* O ambiente administrativo é separado (/admin): aqui só o atalho,
              e só para administrador. Comum e Profissional não veem nada dele. */}
          {ehAdministrador(usuario) &&
            <Link to="/admin" className="nav-item" title={colapsado ? "Painel administrativo" : undefined}>
              <img src={gerenciamento_icon} alt="" />
              <span>Painel administrativo</span>
              {pendentes > 0 && <b className="badge" aria-label={`${pendentes} pedidos pendentes`}>{pendentes}</b>}
            </Link>
          }

          <div className="nav-item" title={colapsado ? "Sair" : undefined} onClick={()=>setShowLogout(true)}>
          <img src={logout_icon} alt="Icone de logout" />
          <span>Sair</span>
          </div>


        </nav>
      </div>
      <div className="panel">
        {children}
      </div>


      {showLogout &&
        <DeleteDialog
          titulo={"Sair da conta"}
          subtitulo={"Deseja realmente sair da conta?"}
          onClose={() => setShowLogout(false)}
          textButton={"Sair"}
          onDelete={logout}
        />
      }

    </Content>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);